import { render } from "./PantryDetailDataItem.vue?vue&type=template&id=568fee76&ts=true"
import script from "./PantryDetailDataItem.vue?vue&type=script&lang=ts"
export * from "./PantryDetailDataItem.vue?vue&type=script&lang=ts"

import "./PantryDetailDataItem.vue?vue&type=style&index=0&id=568fee76&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__